module.exports = __webpack_public_path__ + "static/media/focus-bg.b021fc42.avif";